


























import { Component, Prop, Vue } from "vue-property-decorator";
import { COLOR_ALL_DEVICES_DELETE_ICON, COLOR_ALL_DEVICES_EDIT_ICON, COLOR_ALL_DEVICES_SETTINGS_ICON } from "@/utils/colors";
import { DeviceOverview } from "@/data/models/DeviceOverview";
import { DeviceTemplate } from "@/data/models/DeviceTemplate";
import { GenericDeviceFilter } from "@/data/models/DeviceFilter";
import { formatNumber } from "@/utils/Utils";

@Component({
})

export default class DeviceTemplateItem extends Vue {
  @Prop()
  deviceTemplate!: DeviceTemplate;

  @Prop()
  devices!: DeviceOverview[];

  @Prop() elevation!: number;

  @Prop()
  isDefaultBranchFilterSelected!: boolean;

  @Prop()
  noOfTotalDevices!: number;

  @Prop()
  selectedDeviceFilter!: GenericDeviceFilter;

  @Prop({ default: "" })
  backgroundStyle!: string;

  @Prop({ default: false })
  isForEdit: boolean;

  @Prop({ default: false })
  isEditable: boolean;

  @Prop({ default: false })
  isRemovable: boolean;

  @Prop({ default: "mdi-folder-outline" })
  iconResource: string;

  get colorEditIcon() {
    return COLOR_ALL_DEVICES_EDIT_ICON;
  }

  get colorDeleteIcon() {
    return COLOR_ALL_DEVICES_DELETE_ICON;
  }

  get iconColor() {
    return COLOR_ALL_DEVICES_SETTINGS_ICON;
  }

  get showTemplate() {
    return ((this.selectedDeviceFilter === GenericDeviceFilter.ALL_DEVICES && this.isDefaultBranchFilterSelected) ||
      this.devices.length > 0) || this.isForEdit;
  }

  get templateTitle() {
    const templateName = this.deviceTemplate ? this.deviceTemplate.deviceName : this.$t("common.all").toString();
    const noOfDevicesString = 
      (this.selectedDeviceFilter !== GenericDeviceFilter.ALL_DEVICES || !this.isDefaultBranchFilterSelected) && !this.isForEdit
        ? formatNumber(this.devices.length) + "/" + formatNumber(this.noOfTotalDevices)
        : formatNumber(this.devices.length);

    return templateName + " (" + noOfDevicesString + ")";
  }

  onOpenDeviceTemplate() {
    this.$emit("onOpenDeviceTemplate");
  }

  onDeleteTemplate(id: string) {
    this.$emit("onDeleteTemplate", id);
  }
}
